'use client'

import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { ConfirmDialog } from '@/components/confirm-dialog'
import { Button } from '@/components/ui/button'
import { Check, Copy } from 'lucide-react'
import { User } from '../data/schema'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  pass: string
  currentRow: User
}

export function UsersNewPassDialog({ open, onOpenChange, pass, currentRow }: Props) {
  const i18n = useTranslation()
  const [copied, setCopied] = useState(false)

  const copyToClipboard = () => {
    navigator.clipboard.writeText(pass)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <ConfirmDialog
      className='w-[26rem]'
      open={open}
      onOpenChange={onOpenChange}
      handleConfirm={() => {}}
      title={
        <div className='space-y-4'>
          <p className='mb-2 text-right'>
            {i18n.t('new_pass')}
          </p>
        </div>
      }
      desc={
        <div className='space-y-4'>
          <p className='mb-2 text-right'>
            {i18n.t('new_pass_notice', { user: currentRow?.name })}
          </p>
          <div className="flex gap-2 py-4">
            <div className="font-mono bg-muted px-16 py-1 rounded-md text-center text-lg">{pass}</div>
            <Button
              size="icon"
              variant="outline"
              className="flex-shrink-0"
              onClick={copyToClipboard}
              title={i18n.t('clip')}
            >
              {copied ? <Check className="h-4 w-4 text-green-500" /> : <Copy className="h-4 w-4" />}
            </Button>
          </div>
        </div>
      }
      cancelBtnText={i18n.t('close')}
    />
  )
}
